export default __webpack_public_path__ + "static/media/FaithLanham_headshot.1299c2e0.jpg";